export const ENUM_PECAHAN_IDS = {
  PECAHAN_100000: { id: 1, value: 100000, label: "100.000" },
  PECAHAN_75000: { id: 2, value: 75000, label: "75.000" },
  PECAHAN_50000: { id: 3, value: 50000, label: "50.000" },
  PECAHAN_20000: { id: 4, value: 20000, label: "20.000" },
  PECAHAN_10000: { id: 5, value: 10000, label: "10.000" },
  PECAHAN_5000: { id: 6, value: 5000, label: "5.000" },
  PECAHAN_2000: { id: 7, value: 2000, label: "2.000" },
  PECAHAN_1000: { id: 8, value: 1000, label: "1.000" },
  PECAHAN_500: { id: 9, value: 500, label: "500" },
  PECAHAN_200: { id: 10, value: 200, label: "200" },
  PECAHAN_100: { id: 11, value: 100, label: "100" },
};

export const ENUM_TYPE = {
  LACI: { id: 1, label: "Laci" },
  BRANKAS: { id: 2, label: "Brankas" },
  FINANCE: { id: 3, label: "Finance" },
  KAS_KECIL: { id: 3, label: "Kas Kecil" },
};

export const ENUM_SHIFT = {
  PAGI: { id: 1, label: "Pagi" },
  SIANG: { id: 2, label: "Siang" },
  MALAM: { id: 3, label: "Malam" },
};

export const STATUS_KAS_KECIL = {
  PENDING: 0,
  BERJALAN: 1,
  REQUEST_CLOSED: 2,
  APPROVED_KC: 3,
  PENDING_PENGEMBALIAN: 4,
  CLOSED: 5,
};

export const STATUS_LOG = {
  OK: 1,
  VOID: 2,
  SEDANG_PEMESANAN: 3,
  REFUND: 5,
};

export const OPTIONS_PECAHAN_IDS = Object.values(ENUM_PECAHAN_IDS).map((item) => ({
  value: item.id,
  text: item.label,
  nominal: item.value,
}));

export const OPTIONS_TYPE = Object.values(ENUM_TYPE).map((item) => ({
  value: item.id,
  text: item.label,
}));

export const OPTIONS_SHIFT = Object.values(ENUM_SHIFT).map((item) => ({
  value: item.id,
  text: item.label,
}));
